export default __webpack_public_path__ + "static/media/red.a2823f28.svg";